import {
  CmdHotkey,
  Digit0Hotkey,
  Digit1Hotkey,
  ShiftHotkey,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  type: '100%' | 'fit'
}

// todo: move to general components
export const Shortcut: React.FC<Props> = ({ type }) => {
  if (type === 'fit') {
    return (
      <div className={css.shortcut}>
        <ShiftHotkey className={css.icon} />
        <Digit1Hotkey className={css.icon} />
      </div>
    )
  }

  return (
    <div className={css.shortcut}>
      <CmdHotkey className={css.icon} />
      <Digit0Hotkey className={css.icon} />
    </div>
  )
}
